<div class="cargo-information-container">
  <div>
    <h1>Детали перевозки</h1>

    <div class="container">
      <div class="container__item align-items--flex-end_el-form-item__content container__item--order--1">
        <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--40-p">
          <el-col :span="11">
            <el-form-item label="" prop="applicationCargoPickup.deliveryToTheAddress">
              <el-switch
                v-model="dataForm.applicationCargoPickup.deliveryToTheAddress"
                active-text="Доставка"
                @change="dataForm.calculator.isDelivery = dataForm.applicationCargoPickup.deliveryToTheAddress ? 'Доставка до двери' : 'Забрать на складе'"
              />
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item label="Адрес доставки" prop="applicationCargoPickup.addressConsignee">
              <el-dropdown ref="addressDropdown" trigger="contextmenu">
                <div class="dropdown-input-area"></div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item v-for="(option, index) in toAddressList" :key="index" @click.native="setAddress(option.value)" :disabled="option.disabled" v-bind:class="option.class">
                      {{ option.value }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <el-input
                v-model="dataForm.applicationCargoPickup.addressConsignee"
                placeholder="Введите адрес"
                :disabled="!dataForm.applicationCargoPickup.deliveryToTheAddress"
                @input="getAddress"
                @click="clickAddress"
                v-cancel-read-only
                autocomplete="do-not-autofill"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>
      <div class="container__item align-items--flex-end_el-form-item__content container__item--order--0">
        <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--30-p">
          <el-col :span="11">
            <el-form-item prop="services.cashOnDelivery">
              <el-switch v-model="dataForm.services.cashOnDelivery" @click="dataForm.services.cashOnDeliverySum = null" active-text="Наложенный платёж" @change="handlerCashOnDelivery()" />
            </el-form-item>
          </el-col>

          <el-col :span="2" />

          <el-col :span="11">
            <el-form-item label="Сумма наложенного платежа" class="services-partial-container__label-padding--0" prop="services.cashOnDeliverySum" :required="dataForm.services.cashOnDelivery">
              <el-input type="number" v-model="dataForm.services.cashOnDeliverySum" :disabled="!dataForm.services.cashOnDelivery" />
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>
      <div class="container__item align-items--flex-end_el-form-item__content container__item--order--3">
        <el-form-item label="Объявленная стоимость груза" prop="cargoInformation.cargoCost" class="margin-bottom--30-p">
          <el-input type="number" v-model="dataForm.cargoInformation.cargoCost" min="0" @change="checkCargoCost" />
          <div class="total-weight--error" v-if="(dataForm.cargoInformation.cargoCost >= 30000)">
            Обрешетка может быть обязательной - в зависимости от <a target="_blank" href="https://xn----stbeziy.xn--p1ai/dlya-klienta/udorozhanie">характера груза</a>
          </div>
        </el-form-item>
      </div>
      <div class="container__item align-items--flex-end_el-form-item__content container__item--order--2 container__item--top-indentation--20">
        <el-form-item v-if="dataForm.cargoInformation.typeOfCargo !== 'Шины'" class="margin-bottom--30-p">
          <el-col :span="11">
            <el-form-item prop="services.returnOfDocuments">
              <el-switch v-model="dataForm.services.returnOfDocuments" active-text="Возврат документов" />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <el-form-item prop="services.warmPlace">
              <el-switch v-model="dataForm.services.warmPlace" active-text="Тёплое место" :disabled="checkDisabledWarmplace()" />
            </el-form-item>
            <div class="warmplace__text" v-if="dataForm.cargoInformation.cargoWeight > 30">Максимальная масса - 30кг</div>
          </el-col>
        </el-form-item>
      </div>
    </div>

    <div class="container">
      <div class="container__item">
        <el-form-item class="align-items--flex-end_el-form-item__content margin-bottom--30-p">
          <el-col :span="11">
            <el-form-item>
              <el-switch
                v-model="dataForm.cargoInformation.additionalPackaging"
                active-text="Доп. упаковка"
                @change="dataForm.cargoInformation.typeOfPackaging = dataForm.cargoInformation.additionalPackaging ? dataForm.cargoInformation.typeOfPackaging : []"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <el-form-item class="cargo-information-container__type-of-packaging" label="Тип упаковки" prop="cargoInformation.typeOfPackaging" :required="dataForm.cargoInformation.additionalPackaging">
              <el-select
                v-model="dataForm.cargoInformation.typeOfPackaging"
                placeholder="Выберите вариант"
                multiple
                collapse-tags
                collapse-tags-tooltip
                :disabled="!dataForm.cargoInformation.additionalPackaging"
                @change="checkPackageType"
              >
                <el-option v-for="type in typeOfPackagings" :key="type.value" :label="type.label" :value="type.value" :disabled="checkIntersectionsTypes(type.disabled, type.label)" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>

      <div class="container__item">
        <el-form-item>
          <el-col :span="24">
            <el-form-item label="Характер груза" prop="cargoInformation.natureOfCargo">
              <el-input v-model="dataForm.cargoInformation.natureOfCargo" type="textarea" />
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>
    </div>
    <div class="typeNumberWrapper">
      <el-form-item label="Вид груза" prop="cargoInformation.typeOfCargo">
        <el-select v-model="dataForm.cargoInformation.typeOfCargo" placeholder="Выберите вариант">
          <el-option v-for="type in typeOfCargos" :key="type.value" :label="type.label" :value="type.value" />
        </el-select>
      </el-form-item>

      <el-form-item prop="cargoInformation.numberOfIdenticalLoads" label="Количество мест">
        <el-input min="1" v-model="dataForm.cargoInformation.numberOfIdenticalLoads" @change="checkNumberOfIdenticalLoads" type="number" style="width: 134px">
          <template #append>шт.</template>
        </el-input>
      </el-form-item>
    </div>
  </div>

  <div class="bord_button">
    <el-form-item>
      <el-button class="button_send" type="primary" @click="$emit('click-button-back')"> Назад </el-button>
    </el-form-item>
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next', [...getArrayOfRules(dataForm.applicationCargoPickup, 'applicationCargoPickup'), ...getArrayOfRules(dataForm.cargoInformation, 'cargoInformation'), ...getArrayOfRules(dataForm.services, 'services'),])"
      >
        Далее
      </el-button>
    </el-form-item>
  </div>
</div>
